import React from 'react'
import ImageBoxWrapper from './ImageBoxWrapper'
import FirstBox from './StyledFirstBox'
import SmallBox from './StyledSmallBox'
import ContainerRow from './StyledContainerRow'
import LeftColumn from './StyledLeftColumn'
import RightColumn from './StyledRightColumn'
import { type DynamicleadWidgetProps } from './Types'

export default (props: DynamicleadWidgetProps) => {
  const {
    widget: {
      boxes,
      name,
      imageSize,
      utmContent,
      utmMedium,
      utmSource
    }
  } = props

  if (!boxes || !boxes.length) return null

  const smallBoxes = [ ...boxes ]
  const firstBox = Object.assign({}, smallBoxes.shift(), {
    featuredSize: 'big'
  })

  const utmParams = {
    utmContent,
    utmMedium,
    utmSource
  }

  const renderSmallImageBox = (box, index) => <ImageBoxWrapper
    box={box}
    imageBoxComponent={SmallBox}
    imageSize={imageSize}
    index={index + 1}
    key={`dynamicLeadBox${index + 1}`}
    utmParams={utmParams}
  />

  return (
    <ContainerRow id={name}>
      <LeftColumn>
        <ImageBoxWrapper
          box={firstBox}
          imageBoxComponent={FirstBox}
          imageSize='1_1L'
          index={0}
          utmParams={utmParams}
        />
      </LeftColumn>
      <RightColumn>
        {
          smallBoxes.map(renderSmallImageBox)
        }
      </RightColumn>
    </ContainerRow>
  )
}
